import * as React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@fluentui/react-components";
import Taskpane from "./Taskpane";
import { AuthProvider } from "../contexts/AuthContext";
import "jspreadsheet-ce/dist/jspreadsheet.css";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    background:
      "linear-gradient(150deg, rgba(247, 250, 255, 1) 25%, rgba(240, 245, 255, 1) 50%, rgba(227, 236, 255, 1) 100%)",
  },
});

const App = (props) => {
  const { title } = props;
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <AuthProvider>
        <Taskpane />
      </AuthProvider>
    </div>
  );
};

App.propTypes = {
  title: PropTypes.string,
};

export default App;
